export { default as FooterContainer } from './FooterContainer'
export { default as Footer } from './Footer'
export { default as ResetFooter } from './ResetFooter'
export { default as IuppFooter } from './IuppFooter'



// WEBPACK FOOTER //
// ./src/App/Footer/index.js